import React from 'react';

/**
 * Marchio di NexorAI: nodi collegati con sfumatura ciano → viola → magenta.
 * È lo stesso disegno di public/favicon.svg e public/logo-mark.svg.
 */
function NexoraLogo({ className }) {
  return (
    <svg className={`nx-logo${className ? ` ${className}` : ''}`} viewBox="105 35 570 570" aria-hidden="true">
      <defs>
        <linearGradient id="nx-logo-grad" gradientUnits="userSpaceOnUse" x1="140" y1="80" x2="600" y2="560">
          <stop offset="0" stopColor="#00c0f2" />
          <stop offset="0.5" stopColor="#6f4fcb" />
          <stop offset="0.9" stopColor="#e414c4" />
        </linearGradient>
      </defs>
      <g fill="none" stroke="url(#nx-logo-grad)" strokeWidth="30" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="383" cy="125" r="62" />
        <circle cx="543" cy="172" r="50" />
        <circle cx="205" cy="310" r="62" />
        <circle cx="415" cy="497" r="62" />
        <path d="M574 270 A62 62 0 1 1 532 309" />
        <path d="M337 320 A58 58 0 0 0 453 320 Q490 318 532 309" />
        <path d="M352 178 Q320 225 255 268" />
        <path d="M392 185 Q380 250 450 275 Q490 260 518 215" />
        <path d="M249 354 Q300 420 394 440" />
        <path d="M446 443 Q500 420 550 378" />
      </g>
    </svg>
  );
}

export default NexoraLogo;
